import React, { useState, useEffect } from 'react';
import TodaysSalesReport from './TodaysSalesReport';

const OnboardingTSRWrapper = ({ goTo, onComplete }) => {
  // Skip animation during onboarding - go directly to TSR
  const [showAnimation, setShowAnimation] = useState(false);
  const [animationStep, setAnimationStep] = useState(0);

  useEffect(() => {
    // Animation disabled for onboarding
    // const timers = [
    //   setTimeout(() => setAnimationStep(1), 500),
    //   setTimeout(() => setAnimationStep(2), 1500),
    //   setTimeout(() => setAnimationStep(3), 3000),
    //   setTimeout(() => setShowAnimation(false), 4500)
    // ];

    // return () => timers.forEach(t => clearTimeout(t));
  }, []);

  if (showAnimation) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
        animation: animationStep >= 3 ? 'fadeOut 0.5s ease-out' : 'none'
      }}>
        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes fadeOut {
            from { opacity: 1; }
            to { opacity: 0; }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.1); }
          }
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>

        {/* Step 1: Icon */}
        <div style={{
          fontSize: '80px',
          marginBottom: '30px',
          animation: animationStep >= 1 ? 'pulse 0.6s ease-out' : 'none',
          opacity: animationStep >= 1 ? 1 : 0
        }}>
          📊
        </div>

        {/* Step 2: Title */}
        <div style={{
          fontSize: '28px',
          fontWeight: 'bold',
          color: 'white',
          textAlign: 'center',
          marginBottom: '16px',
          animation: animationStep >= 2 ? 'slideUp 0.5s ease-out' : 'none',
          opacity: animationStep >= 2 ? 1 : 0
        }}>
          Almost Done! 🎉
        </div>

        {/* Step 3: Description */}
        <div style={{
          fontSize: '18px',
          color: 'rgba(255, 255, 255, 0.9)',
          textAlign: 'center',
          maxWidth: '600px',
          lineHeight: '1.6',
          animation: animationStep >= 3 ? 'slideUp 0.5s ease-out' : 'none',
          opacity: animationStep >= 3 ? 1 : 0,
          padding: '0 20px'
        }}>
          <div style={{ marginBottom: '12px' }}>
            Please upload your <strong>sales reports from the past 2 days</strong>
          </div>
          <div style={{ fontSize: '16px', opacity: 0.8 }}>
            This helps us set up your initial inventory accurately
          </div>
        </div>

        {/* Progress indicator */}
        <div style={{
          position: 'absolute',
          bottom: '40px',
          display: 'flex',
          gap: '8px'
        }}>
          {[1, 2, 3, 4, 5].map(step => (
            <div key={step} style={{
              width: step === 4 ? '24px' : '8px',
              height: '8px',
              borderRadius: '4px',
              background: step === 4 ? 'white' : 'rgba(255, 255, 255, 0.3)',
              transition: 'all 0.3s ease'
            }} />
          ))}
        </div>
      </div>
    );
  }

  // Calculate yesterday's date for onboarding TSR submission
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayDate = yesterday.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });

  return (
    <TodaysSalesReport 
      goTo={goTo} 
      onComplete={onComplete} 
      isOnboarding={true}
      targetDate={yesterdayDate}
    />
  );
};

export default OnboardingTSRWrapper;
